
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from './controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import cliente from './resumen-cliente.vue';
    import items from './resumen-items.vue';
    import facturas from './resumen-facturas.vue';

    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import _ from 'lodash';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            cliente,
            items,
            facturas,

        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Seleccionados() { return this.Controlador.Seleccionados; }
        @Watch( 'Seleccionados' )
        onSeleccionados()
        {
            if ( this.Seleccionados.hasRows() )
            {
                this.SubModo = '';
                this.Abierto = true;
                this.Pedido = this.Seleccionados[0];
            }
            else
                this.Abierto = false;
        }

        public Pedido: Pedido = null;
        public Abierto: boolean = false;

        public SubModo: string = '';

        public get SeleccionadosPorTipo()
        {
            let e: { Tipo: any; Pedidos: Pedido[]; }[] = [];
            let items = _.groupBy( this.Seleccionados, x => x.Tipo.Id );
            for ( let a of Object.keys( items ) )
            {
                e.push( { Tipo: Pedidos.Tipos.toTipo( a ), Pedidos: items[a] } );
            }
            return e;
        }

        public get Estado() { return this.Controlador.Buscador.Estado; }

        public get PermiteEntregar()
        {
            if ( !this.Pedido )
                return;

            return this.Pedido.Tags.Facturado &&
                   this.Pedido.Envio.Tipo.esRetiraCliente &&
                   !this.Pedido.Estado.esEntregado;
        }

        Cerrar()
        {
            this.Seleccionados.clear();
        }

        public Cargando: boolean = false;
        async Entregar()
        {
            this.Cargando = true;
            if ( this.PermiteEntregar )
            {
                if ( await Utiles.Mensajes.SiNo( 'Entregar', '¿Entregar este pedido?' ) )
                {
                    let e = await this.Pedido.Envio.Entregar();
                    if ( e )
                    {
                        this.Pedido.Estado = Pedidos.Estados.Entregado;
                        this.Controlador.RecargarEstadistica();
                    } else
                    {
                        Utiles.Notificaciones.Error( 'Error al modificar estado' );

                    }

                }
            }
            this.Cargando = false;
        }
    }
